import React from "react";
import { useSelector } from "react-redux";
import { mediaVideo, audioRecordImg, audioFileImg, NoMediaHoc, NextHoc } from "../../../assets/images";
import { MEDIA_AND_DOCS } from "../../../processENV";
import { getActiveChatMessages, getActiveConversationChatJid } from "../../../Helpers/Chat/ChatHelper";
import { MEDIA_MESSAGE_TYPES } from "../../../Helpers/Constants";
import SDK from "../../../SDK";
import { getExtension } from "../Common/FileUploadValidation";
import getFileFromType from "../ConversationSection/Conversation/Templates/Common/getFileFromType";
import { millisToMinutesAndSeconds } from "../../../Helpers/Utility";
import { resetSingleChatSelectedMedia, singleChatSelectedMedia } from "../../../Redux/feature/singleChatSelectedMediaSlice";
import { store } from "../../../Redux/store";

const WebChatContactInfoMedia = (props = {}) => {
    const { chatType = "" } = props;
    const { isViewAllMediasEnabled = false } = useSelector((state) => state.featureFlagList.data);
    const singleChatMediaData = useSelector((state) => state.singleChatSelectedMediaData.data);
    const chatConversationHistory = useSelector((state) => state.chatConversationHistory.data);
    const [mediaList, setMediaList] = React.useState([]);
    const [initialCall,setInitialCall] = React.useState(false);

    React.useEffect(() => {
        const chatMediaList = getActiveChatMessages();
        let mediaListData = chatMediaList.filter(
            (el) => el && el.msgBody && MEDIA_MESSAGE_TYPES.includes(el.msgBody.message_type) && el.deleteStatus === 0 && el.msgStatus !== 3
            );
        mediaListData.sort((a, b) => (b.timestamp > a.timestamp ? 1 : -1));
        setMediaList(mediaListData);
        setInitialCall(true)
        return () => {
            store.dispatch(resetSingleChatSelectedMedia());
        }
    }, [chatConversationHistory])

    React.useEffect(()=>{
    // Show Only 3 Recent Medias. If it has less than 3 Fetch from Server
    if (mediaList.length < 3 && initialCall) handleGetMedia();
    else mediaList.length = 3;
    },[mediaList])

    React.useEffect(() => {
        if (singleChatMediaData.length && singleChatMediaData.length !== 0) {
            setMediaList(singleChatMediaData.reverse());
        }
    }, [singleChatMediaData])

    const handleGetMedia = async () => {
        let chatJid = getActiveConversationChatJid();
        if (chatType === "broadcast") {
            // Not Implemented
            SDK.getBroadcastChatMedia(chatJid);
        } else {
            const mediaMsgRes = SDK && (await SDK.getMediaMessages(chatJid));
            if (mediaMsgRes && mediaMsgRes.statusCode === 200 && mediaMsgRes.data.length) {
                // Filtering Media Duplicates with Message Id
                const msgIds = new Set(mediaList.map((d) => d.msgId));
                const newList = [...mediaList, ...mediaMsgRes.data.filter((d) => !msgIds.has(d.msgId))];
                newList.sort((a, b) => (b.timestamp > a.timestamp ? 1 : -1));
                setMediaList(newList);
                setInitialCall(false)
            }
        }
    };

    const handleMediaShow = (e) => {
        document
            .getElementById("msgContent")
            .querySelectorAll("video, audio")
            .forEach((element) => element.pause());

        if (mediaList.length > 0) {
            const data = {
                jid: getActiveConversationChatJid(),
                chatType: chatType ? "chat" : "groupchat",
                selectedMessageData: mediaList[0]
            };
            store.dispatch(singleChatSelectedMedia(data));
        }
    };

    const handleSelectedMediaAction = (messageObject) => {
        const data = { jid: getActiveConversationChatJid(), chatType: chatType, selectedMessageData: messageObject };
        store.dispatch(singleChatSelectedMedia(data));
    }

    return (
        <div>
            {isViewAllMediasEnabled &&
                <div className="contactinfo-media">
                    <h5>
                        <span className="media">
                            {MEDIA_AND_DOCS}
                        </span>
                        {mediaList.length !== 0 && (
                            <span
                                className="count"
                                onClick={handleMediaShow}
                                data-jest-id={"jesthandleMediaShow"}
                            >
                                <i>
                                    <NextHoc viewBox="0 0 7.201 12.001" />
                                </i>
                            </span>
                        )}
                    </h5>
                    {mediaList.length !== 0 &&
                        <ul className="mediadocs">
                            {mediaList.map((media, index) => {
                                let audioType = media?.msgBody?.media?.audioType;
                                let msgObj = media?.msgBody ? media?.msgBody : media;
                                let {
                                    message_type,
                                    media: { fileName = null, thumb_image = null, duration = "", file_url = "" } = {}
                                } = msgObj;
                                let imageSrc = thumb_image ? `data:image/png;base64,${thumb_image}` : file_url;
                                const fileExtension = getExtension(fileName);
                                const placeholder = getFileFromType(null, fileExtension);

                                if (message_type === "image") {
                                    return (
                                        <li onClick={() => handleSelectedMediaAction(media)} key={media.fromUserId}>
                                            <img src={imageSrc} alt="" />
                                        </li>
                                    );
                                } else if (message_type === "video") {
                                    return (
                                        <li onClick={() => handleSelectedMediaAction(media)} key={media.fromUserId} className="media-video">
                                            <img src={imageSrc} alt="" />
                                            <div className="overlay">
                                                <img src={mediaVideo} className="video-icon" alt="" />
                                            </div>
                                        </li>
                                    );
                                } else if (message_type === "audio") {
                                    return (
                                        <li key={media.fromUserId} className="media-audio">
                                            <span className="media-inner">
                                                <span className="media-text">
                                                    {millisToMinutesAndSeconds(duration)}
                                                </span>
                                                <img
                                                    alt=""
                                                    src={audioType !== "recording" ? audioFileImg : audioRecordImg}
                                                />
                                            </span>
                                        </li>
                                    );
                                } else if (message_type === "file") {
                                    return (
                                        <li key={media.fromUserId} className="media-file">
                                            <span className="media-inner">
                                                <span className="media-text">
                                                    {fileName}
                                                </span>
                                                <img src={placeholder} alt="" />
                                            </span>
                                        </li>
                                    );
                                }
                                return "";
                            })}
                        </ul>
                    }

                    {mediaList.length === 0 && (
                        <div className="noMedia">
                            <i>
                                <NoMediaHoc viewBox="0 0 101.3 78.815" />
                            </i>
                            <span className="">No Media Found</span>
                        </div>
                    )}
                </div>
            }
        </div>
    );
}

export default WebChatContactInfoMedia